import React from "react";
import { Link } from "react-router-dom";
import "./style.less";
import { Layout, Menu } from "antd";
import Nav from "../Nav";

const { Sider } = Layout;
const clsPrefix = "c-charge-record";

class MainLayout extends React.Component {
  getSelectedKeyByRoute = () => {
    let currentRoute = window.location.pathname;
    let selectedKey = null;
    switch (currentRoute) {
      case "/v5/invoice/recordTable":
        selectedKey = ["1"];
        break;

      case "/v5/invoice/invoiceList":
        selectedKey = ["2"];
        break;

      default:
        selectedKey = ["1"];
        break;
    }
    return selectedKey;
  };

  render() {
    return (
      <div className={clsPrefix}>
        <Nav />
        <Layout style={{ maxHeight: "0"}}>
          <Sider className="main-sider" theme="light">
            <Menu
              theme="light"
              mode="inline"
              defaultSelectedKeys={this.getSelectedKeyByRoute()}
            >
              <Menu.Item key="1">
                <Link to="/v5/invoice/recordTable">充值记录</Link>
              </Menu.Item>
              <Menu.Item key="2">
                <Link to="/v5/invoice/invoiceList">发票列表</Link>
              </Menu.Item>
            </Menu>
          </Sider>
        </Layout>
      </div>
    );
  }
}

export default MainLayout;
